import React, { useRef, useEffect, useState } from 'react';
import { StringHelpers, SystemText } from 'e4shared';
import config from '../../../../../../../config';
import ReactMediaRecorder from '../mediaRecorder';

const Timer = props => {
    return <span>{StringHelpers.displaySeconds(props.clock)}</span>;
};

export const ScreenRecorder = ({ value, fileName, onChange, forceUpdate }) => {
    const previewRef = useRef(null);

    const defaultReadyFont = 90;

    const [hasCreated, setHasCreated] = useState(false);
    const [playing, setPlaying] = useState(false);
    const [recording, setRecording] = useState(false);
    const [clock, setClock] = useState(false);
    const [readying, setReadying] = useState(null);

    const streamingUrl = value && `${config.storage.URL}${config.environment}/${value.url}`;

    const onStartRecording = callback => {
        setPlaying(false);
        setRecording(true);

        const interval = setInterval(() => {
            setReadying(readying => (readying === null ? 3 : readying - 0.5));
        }, 500);

        setTimeout(() => {
            clearInterval(interval);
            setReadying(null);
            callback();
        }, 3000);
    };

    const onStopRecording = async blobUrl => {
        setHasCreated(true);
        setRecording(false);
        await fetch(blobUrl)
            .then(r => r.blob())
            .then(blobFile => new File([blobFile], `${fileName}.mp4`, { type: 'video/mp4' }))
            .then(file => onChange?.(file));
    };

    const onPlay = () => {
        setPlaying(true);

        const playInterval = setInterval(() => {
            if (previewRef.current) {
                previewRef.current.play();
                clearInterval(playInterval);
            }
        }, 100);
    };

    const onPause = () => {
        setPlaying(false);
        previewRef.current?.pause();
    };

    const changeTarget = callback => {
        setPlaying(false);
        callback();
    };

    const VideoPreview = ({ stream }) => {
        const videoRef = useRef(null);

        useEffect(() => {
            if (videoRef.current && stream) {
                videoRef.current.srcObject = stream;
            }
        }, [stream]);

        if (!stream) {
            return null;
        }

        return <video ref={videoRef} width="100%" autoPlay controls={false} />;
    };

    return (
        <div>
            <div className="video-recorder mb10" style={{ width: `100%` }}>
                <ReactMediaRecorder
                    video={false}
                    screen
                    onStop={onStopRecording}
                    render={recorderProps => {
                        const aquiring = recorderProps.status === 'acquiring_media';
                        let mode = 'INFO';
                        if (streamingUrl && !hasCreated) mode = 'PLAY';
                        if (recorderProps.status === 'recording') mode = 'PREVIEW';
                        if (recorderProps.status === 'stopped') mode = 'PLAY';
                        if (playing) mode = 'PLAY';
                        if (readying) mode = 'INFO';
                        if (recorderProps.error !== 'NONE') mode = 'INFO';
                        if (recorderProps.error === 'NotAllowedError') mode = 'INFO';

                        return (
                            <div>
                                <div className="video-container">
                                    {mode === 'PREVIEW' && <VideoPreview stream={recorderProps.previewStream} />}
                                    {mode === 'INFO' && <div style={{ width: `100%`, height: '300px' }}></div>}
                                    {mode === 'PLAY' && (
                                        <video
                                            ref={previewRef}
                                            onPlay={() => setPlaying(true)}
                                            onPause={() => setPlaying(false)}
                                            style={{ width: `100%` }}
                                            src={recorderProps.mediaBlobUrl || streamingUrl}
                                            onTimeUpdate={() => setClock(Math.floor(previewRef.current.currentTime))}
                                            controls
                                        />
                                    )}
                                </div>
                                {(recorderProps.status === 'recording' || readying) && (
                                    <div
                                        className="recording-icon"
                                        style={{
                                            display:
                                                readying % 1 === 0 || recorderProps.status === 'recording' ? '' : 'none',
                                        }}
                                    >
                                        <i
                                            className={`fa fa-2x ${
                                                recorderProps.status === 'recording' ? 'fa-circle-play' : 'fa-circle-stop'
                                            } text-danger`}
                                        />
                                    </div>
                                )}
                                {mode === 'INFO' ? (
                                    readying !== null ? (
                                        <div
                                            className="readying"
                                            style={{
                                                top: undefined,
                                                left: '45%',
                                                padding: 'auto',
                                                fontSize: `${defaultReadyFont}px`,
                                            }}
                                        >
                                            {Math.ceil(readying)}
                                        </div>
                                    ) : recorderProps.error === 'Permission denied' ||
                                      recorderProps.error === 'NotAllowedError' ? (
                                        <div
                                            className="information"
                                            style={{
                                                top: `50px`,
                                            }}
                                        >
                                            {SystemText('General/Controls/ScreenRecorder/SelectWindow')}
                                            <br />
                                            <br />
                                            <button
                                                data-testid="button-select"
                                                className="btn btn-sm btn-primary"
                                                onClick={() => forceUpdate?.()}
                                            >
                                                {SystemText('General/Controls/ScreenRecorder/Buttons/Select')}
                                            </button>
                                        </div>
                                    ) : recorderProps.error !== 'NONE' ? (
                                        <div
                                            className="text-center information"
                                            style={{
                                                top: `50px`,
                                            }}
                                        >
                                            <h4>An error has occurred</h4>
                                            <br />
                                            {recorderProps.error}
                                        </div>
                                    ) : recorderProps.status === 'idle' ? (
                                        <div
                                            className="information"
                                            style={{
                                                top: `50px`,
                                            }}
                                        >
                                            {SystemText('General/Controls/ScreenRecorder/Ready')}
                                        </div>
                                    ) : null
                                ) : null}

                                <div className="video-buttons">
                                    {recorderProps.status === 'recording' ? (
                                        <button
                                            data-testid="button-stop"
                                            className="btn btn-primary mr5 btn-danger"
                                            onClick={recorderProps.stopRecording}
                                            title={SystemText('General/Controls/ScreenRecorder/Buttons/Stop')}
                                        >
                                            <i className="fa fa-stop" />
                                        </button>
                                    ) : (
                                        <button
                                            data-testid="button-record"
                                            disabled={
                                                recorderProps.error === 'Permission denied' ||
                                                recorderProps.error === 'NotAllowedError' ||
                                                aquiring
                                            }
                                            className="btn btn-primary mr5 btn-danger"
                                            onClick={() => onStartRecording(recorderProps.startRecording)}
                                            title={SystemText('General/Controls/ScreenRecorder/Buttons/Record')}
                                        >
                                            <i className="fa fa-circle-dot" />
                                        </button>
                                    )}
                                    <button
                                        data-testid="button-play-pause"
                                        className="btn btn-primary mr5"
                                        onClick={() => (playing ? onPause() : onPlay())}
                                        id="play"
                                        disabled={
                                            recorderProps.status === 'recording' ||
                                            (!recorderProps.mediaBlobUrl && !streamingUrl)
                                        }
                                        title={SystemText(
                                            `General/Controls/ScreenRecorder/Buttons/${playing ? 'Pause' : 'Play'}`
                                        )}
                                    >
                                        <i className={`fa fa-${playing ? 'pause' : 'play'}`} />
                                    </button>
                                    <button
                                        data-testid="button-restore"
                                        className="btn btn-default"
                                        disabled={
                                            recording ||
                                            playing ||
                                            recorderProps.error === 'Permission denied' ||
                                            recorderProps.error === 'NotAllowedError' ||
                                            aquiring
                                        }
                                        title={SystemText('General/Controls/ScreenRecorder/Buttons/Change')}
                                        onClick={() => changeTarget(recorderProps.changeStream)}
                                    >
                                        <i className="fa fa-window-restore" />
                                    </button>
                                </div>
                                <div className="video-time">{playing ? <Timer clock={clock} /> : <span>--:--</span>}</div>
                            </div>
                        );
                    }}
                />
            </div>
        </div>
    );
};

export default ScreenRecorder;
